// extracted by mini-css-extract-plugin
module.exports = {"lotStatusToast":"style_lotStatusToast__V2Pl7"};